var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"mr-2",attrs:{"indeterminate":"","size":"20","width":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }